import { Component, Vue, Watch, Prop, Model, Emit } from 'vue-property-decorator'
import moment, { Moment } from 'moment'
import { Day } from '../types'
import { ShiftDTO, ShiftDetailDTO, ShiftVO, ShiftUpdateDTO } from '@/service-proxies/app-v2/time.service-proxies'
import i18n from '@/locales'
import { state } from '../store'
import { Reactive } from '@/utils/decorators'

@Component
class Time extends Vue {
  @Model('change')
  @Prop()
  value: number
  @Prop({ default: false })
  disabled: boolean
  @Prop({
    default: () => [
      { label: i18n.t('page_shift_model_last_day'), value: 'yesterday' },
      { label: i18n.t('page_shift_model_today'), value: 'today' },
      { label: i18n.t('page_shift_model_next_day'), value: 'tomorrow' },
    ],
  })
  days: { label: string; value: string }[]

  day: Day = 'today'
  time = moment()

  @Watch('value', { immediate: true })
  changeValue(val: number) {
    if (val < 0) {
      this.day = 'yesterday'
      this.time = moment(moment(moment().format('YYYY-MM-DD')).valueOf() + (val + 1440) * 60 * 1000)
    } else if (val < 1440) {
      this.day = 'today'
      this.time = moment(moment(moment().format('YYYY-MM-DD')).valueOf() + val * 60 * 1000)
    } else {
      this.day = 'tomorrow'
      this.time = moment(moment(moment().format('YYYY-MM-DD')).valueOf() + (val - 1440) * 60 * 1000)
    }
  }

  @Emit('change')
  emitChange(day: Day, time: Moment): number {
    const prefix = day === 'yesterday' ? -1440 : day === 'today' ? 0 : 1440
    const today = moment(moment().format('YYYY-MM-DD')).valueOf()
    const minutes = (time.valueOf() - today) / 1000 / 60
    return prefix + Number(minutes.toFixed(0))
  }

  changeDay(val: Day) {
    this.emitChange(val, this.time)
  }

  changeTime(val: Moment) {
    this.emitChange(this.day, val)
  }

  render() {
    return (
      <div style="display: inline-flex; align-items: center">
        <a-select v-model={this.day} disabled={this.disabled} style="width: 80px" onChange={this.changeDay}>
          {this.days.map(item => (
            <a-select-option value={item.value}>{item.label}</a-select-option>
          ))}
        </a-select>
        <a-time-picker
          v-model={this.time}
          disabled={this.disabled}
          format="HH:mm"
          style="width: 128px"
          allowClear={false}
          onChange={this.changeTime}
        />
      </div>
    )
  }
}

@Component
class Color extends Vue {
  @Model('change')
  @Prop()
  value: string

  color = { hex: '' }

  @Watch('color')
  onColorChange(val) {
    // console.log(val)
    // const { r, g, b, a } = val.rgba
    // const color = `rgba(${r}, ${g}, ${b}, ${a})`
    const color = val.hex
    this.emitChange(color)
  }

  @Watch('value', { immediate: true })
  changeColor(val) {
    this.color.hex = val
  }

  @Emit('change')
  emitChange(color: string) {
    return color
  }

  render() {
    return (
      <a-dropdown trigger={['click']}>
        <div
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '4px',
            border: '1px solid #e6e6e6',
            padding: '4px',
            cursor: 'pointer',
            position: 'relative',
          }}
        >
          <div style={{ background: this.value, border: '1px solid #eee', height: '100%' }}></div>
          <a-icon
            type="down"
            style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); color: #fff"
          />
        </div>
        <chrome-picker slot="overlay" v-model={this.color} />
      </a-dropdown>
    )
  }
}

@Component
export default class ModelForm extends Vue {
  @Prop() type: string
  @Prop({ default: () => ({}) }) currentModelDetail: ShiftVO
  body = {
    code: '',
    name: '',
    number: 1,
    startTime: 0,
    endTime: 1440,
    colour: '',
    shiftDetailDTOList: [
      {
        shiftStartTime: 0,
        shiftEndTime: 0,
        shiftIndex: 1,
        indexName: '',
        restNumber: 0,
        shiftRestTimeDTOList: [
          {
            restStartTime: 0,
            restEndTime: 0,
            restIndex: 1,
          },
          {
            restStartTime: 0,
            restEndTime: 0,
            restIndex: 2,
          },
          {
            restStartTime: 0,
            restEndTime: 0,
            restIndex: 3,
          },
          {
            restStartTime: 0,
            restEndTime: 0,
            restIndex: 4,
          },
          {
            restStartTime: 0,
            restEndTime: 0,
            restIndex: 5,
          },
          {
            restStartTime: 0,
            restEndTime: 0,
            restIndex: 6,
          },
        ],
      },
      {
        shiftStartTime: 0,
        shiftEndTime: 0,
        shiftIndex: 2,
        indexName: '',
        restNumber: 0,
        shiftRestTimeDTOList: [
          {
            restStartTime: 0,
            restEndTime: 0,
            restIndex: 1,
          },
          {
            restStartTime: 0,
            restEndTime: 0,
            restIndex: 2,
          },
          {
            restStartTime: 0,
            restEndTime: 0,
            restIndex: 3,
          },
          {
            restStartTime: 0,
            restEndTime: 0,
            restIndex: 4,
          },
          {
            restStartTime: 0,
            restEndTime: 0,
            restIndex: 5,
          },
          {
            restStartTime: 0,
            restEndTime: 0,
            restIndex: 6,
          },
        ],
      },
      {
        shiftStartTime: 0,
        shiftEndTime: 0,
        shiftIndex: 3,
        indexName: '',
        restNumber: 0,
        shiftRestTimeDTOList: [
          {
            restStartTime: 0,
            restEndTime: 0,
            restIndex: 1,
          },
          {
            restStartTime: 0,
            restEndTime: 0,
            restIndex: 2,
          },
          {
            restStartTime: 0,
            restEndTime: 0,
            restIndex: 3,
          },
          {
            restStartTime: 0,
            restEndTime: 0,
            restIndex: 4,
          },
          {
            restStartTime: 0,
            restEndTime: 0,
            restIndex: 5,
          },
          {
            restStartTime: 0,
            restEndTime: 0,
            restIndex: 6,
          },
        ],
      },
      {
        shiftStartTime: 0,
        shiftEndTime: 0,
        shiftIndex: 4,
        indexName: '',
        restNumber: 0,
        shiftRestTimeDTOList: [
          {
            restStartTime: 0,
            restEndTime: 0,
            restIndex: 1,
          },
          {
            restStartTime: 0,
            restEndTime: 0,
            restIndex: 2,
          },
          {
            restStartTime: 0,
            restEndTime: 0,
            restIndex: 3,
          },
          {
            restStartTime: 0,
            restEndTime: 0,
            restIndex: 4,
          },
          {
            restStartTime: 0,
            restEndTime: 0,
            restIndex: 5,
          },
          {
            restStartTime: 0,
            restEndTime: 0,
            restIndex: 6,
          },
        ],
      },
    ] as ShiftDetailDTO[],
  } as ShiftDTO
  currentShiftIndex = 0
  labelCol = { span: 6 }
  wrapperCol = { span: 16 }

  get isUsed() {
    return this.currentModelDetail?.isUsed === 1
  }

  get isUpdate() {
    return this.type === 'update'
  }

  @Watch('body.number')
  onShiftNumberChange(val: number, oldVal: number) {
    if (val < oldVal) {
      this.currentShiftIndex = 0
    }
  }

  @Watch('body.startTime')
  onStartTimeChange(val: number) {
    this.body.endTime = val + 1440
  }

  @Watch('currentModelDetail.id')
  initialDetail(val:ShiftVO) {
    this.initFormData()
  }

  initFormData() {
    if (this.isUpdate) {
      const temp: any = {
        id: this.currentModelDetail.id,
        name: this.currentModelDetail.name,
        code: this.currentModelDetail.code,
        colour: this.currentModelDetail.colour,
        startTime: this.currentModelDetail.startTime,
        endTime: this.currentModelDetail.endTime,
        number: this.currentModelDetail.number,
        shiftDetailDTOList: this.currentModelDetail.shiftDetailVOList.map((item, index) => {
          return {
            modelId: item.id,
            shiftStartTime: item.shiftStartTime,
            shiftEndTime: item.shiftEndTime,
            shiftIndex: item.shiftIndex || index + 1,
            restNumber: item.restNumber,
            indexName: item.indexName,
            shiftRestTimeDTOList: item.shiftRestTimeVOList.map((ite, indx) => {
              return {
                id: ite.id,
                restStartTime: ite.restStartTime,
                restEndTime: ite.restEndTime,
                restIndex: ite.restIndex || indx + 1,
              }
            }),
          }
        }),
      }

      for (let i = 0; i < 4; i++) {
        if (!temp.shiftDetailDTOList[i]) {
          temp.shiftDetailDTOList[i] = {
            shiftStartTime: 0,
            shiftEndTime: 0,
            shiftIndex: i + 1,
            restNumber: 0,
            shiftRestTimeDTOList: [
              {
                restStartTime: 0,
                restEndTime: 0,
                restIndex: 1,
              },
              {
                restStartTime: 0,
                restEndTime: 0,
                restIndex: 2,
              },
              {
                restStartTime: 0,
                restEndTime: 0,
                restIndex: 3,
              },
              {
                restStartTime: 0,
                restEndTime: 0,
                restIndex: 4,
              },
              {
                restStartTime: 0,
                restEndTime: 0,
                restIndex: 5,
              },
              {
                restStartTime: 0,
                restEndTime: 0,
                restIndex: 6,
              },
            ],
          }
        } else {
          for (let j = 0; j < 6; j++) {
            if (!temp.shiftDetailDTOList[i].shiftRestTimeDTOList[j]) {
              temp.shiftDetailDTOList[i].shiftRestTimeDTOList[j] = {
                restStartTime: 0,
                restEndTime: 0,
                restIndex: j + 1,
              }
            }
          }
        }
      }
      this.body = temp
    }
  }

  created() {
    this.initFormData()
  }

  render() {
    return (
      <div>
        <p style="border-left: 4px solid rgb(58, 127, 188);color: rgb(58, 127, 188);padding-left: 8px;margin-bottom: 8px;margin-top: 8px;">{this.$t('page_shift_model_basic_setting')}</p>
        <a-form-item
          label={this.$t('page_shift_model_code')}
          labelCol={this.labelCol}
          wrapperCol={this.wrapperCol}
          required
        >
          <a-input v-model={this.body.code} disabled={this.isUpdate} placeholder={this.$t('common_please_input') as string + this.$t('page_shift_model_code')}/>
        </a-form-item>
        <a-form-item
          label={this.$t('page_shift_model_name')}
          labelCol={this.labelCol}
          wrapperCol={this.wrapperCol}
          required
        >
          <a-input v-model={this.body.name} placeholder={this.$t('common_please_input') as string + this.$t('page_shift_model_name')}/>
        </a-form-item>
        <a-form-item label={this.$t('page_theme_theme_color')} labelCol={this.labelCol} wrapperCol={this.wrapperCol}>
          <Color v-model={this.body.colour} placeholder={this.$t('page_theme_theme_color')} />
        </a-form-item>
        <a-form-item
          label={this.$t('page_shift_model_day_start')}
          labelCol={this.labelCol}
          wrapperCol={this.wrapperCol}
          required
        >
          <Time
            v-model={this.body.startTime}
            days={[
              { label: this.$t('page_shift_model_last_day'), value: 'yesterday' },
              { label: this.$t('page_shift_model_today'), value: 'today' },
            ]}
            disabled={this.isUsed}
          />
        </a-form-item>
        <a-form-item
          label={this.$t('page_shift_model_day_end')}
          labelCol={this.labelCol}
          wrapperCol={this.wrapperCol}
          required
        >
          <Time v-model={this.body.endTime} disabled placeholder={this.$t('page_shift_model_day_end')}/>
        </a-form-item>
        <p style="border-left: 4px solid rgb(58, 127, 188);color: rgb(58, 127, 188);padding-left: 8px;margin-bottom: 8px;margin-top: 8px;">{this.$t('page_shift_model_setting')}</p>
        <a-form-item label={this.$t('page_shift_model_number')} labelCol={this.labelCol} wrapperCol={this.wrapperCol}>
          <a-radio-group v-model={this.body.number} disabled={this.isUsed}>
            <a-radio value={1}>1</a-radio>
            <a-radio value={2}>2</a-radio>
            <a-radio value={3}>3</a-radio>
            <a-radio value={4}>4</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label={this.$t('page_shift_model_list')} labelCol={this.labelCol} wrapperCol={this.wrapperCol}>
          <a-radio-group v-model={this.currentShiftIndex} disabled={this.isUsed}>
            {Array(this.body.number)
              .fill('')
              .map((_, index) => (
                <a-radio-button value={index}>
                  {this.$t('page_shift_model_shift')}
                  {index + 1}
                </a-radio-button>
              ))}
          </a-radio-group>
        </a-form-item>
        <a-form-item label={this.$t('page_console_shift_alias')} labelCol={this.labelCol} wrapperCol={this.wrapperCol}>
          <a-input
            v-model={this.body.shiftDetailDTOList[this.currentShiftIndex].indexName}
            disabled={this.isUsed}
            placeholder={this.$t('common_please_input') as string + this.$t('page_console_shift_alias')}
            style="width: 208px"
          ></a-input>
        </a-form-item>
        <a-form-item
          label={this.$t('page_shift_model_shift_start')}
          labelCol={this.labelCol}
          wrapperCol={this.wrapperCol}
          required
        >
          <Time v-model={this.body.shiftDetailDTOList[this.currentShiftIndex].shiftStartTime} disabled={this.isUsed} />
        </a-form-item>
        <a-form-item
          label={this.$t('page_shift_model_shift_end')}
          labelCol={this.labelCol}
          wrapperCol={this.wrapperCol}
          required
        >
          <Time v-model={this.body.shiftDetailDTOList[this.currentShiftIndex].shiftEndTime} disabled={this.isUsed} />
        </a-form-item>
        <a-form-item
          label={this.$t('page_shift_model_rest_number')}
          labelCol={this.labelCol}
          wrapperCol={this.wrapperCol}
          style="margin: 0px !important"
        >
          <a-radio-group
            v-model={this.body.shiftDetailDTOList[this.currentShiftIndex].restNumber}
            disabled={this.isUsed}
          >
            <a-radio value={0}>0</a-radio>
            <a-radio value={1}>1</a-radio>
            <a-radio value={2}>2</a-radio>
            <a-radio value={3}>3</a-radio>
            <a-radio value={4}>4</a-radio>
            <a-radio value={5}>5</a-radio>
            <a-radio value={6}>6</a-radio>
          </a-radio-group>
        </a-form-item>
        {Array(this.body.shiftDetailDTOList[this.currentShiftIndex].restNumber)
          .fill('')
          .map((_, index) => (
            <div>
              <a-form-item
                label={(this.$t('page_shift_model_rest_start') as string).replace('{0}', String(index + 1))}
                labelCol={this.labelCol}
                wrapperCol={this.wrapperCol}
                required
              >
                <Time
                  v-model={
                    this.body.shiftDetailDTOList[this.currentShiftIndex].shiftRestTimeDTOList[index].restStartTime
                  }
                  disabled={this.isUsed}
                ></Time>
              </a-form-item>
              <a-form-item
                label={(this.$t('page_shift_model_rest_end') as string).replace('{0}', String(index + 1))}
                labelCol={this.labelCol}
                wrapperCol={this.wrapperCol}
                required
              >
                <Time
                  v-model={this.body.shiftDetailDTOList[this.currentShiftIndex].shiftRestTimeDTOList[index].restEndTime}
                  disabled={this.isUsed}
                ></Time>
              </a-form-item>
            </div>
          ))}
      </div>
    )
  }
}
